import { render } from "./ReportsArchiveView.vue?vue&type=template&id=d060b140&scoped=true"
import script from "./ReportsArchiveView.vue?vue&type=script&lang=js"
export * from "./ReportsArchiveView.vue?vue&type=script&lang=js"

import "./ReportsArchiveView.vue?vue&type=style&index=0&id=d060b140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d060b140"]])

export default __exports__